export const MESSAGES = {
  APPOINTMENT_NOT_SET: "Your signing appointment hasn't been set yet.",
  APPOINTMENT_NOT_SET_SOON: 'Someone will reach out soon to confirm a convenient appointment time.',
  PAST_EVENT: 'Past event',
  ADD_CO_SIGNER: 'Add co-signer',
  JOIN_SIGNING_SESSION: 'Join signing session',
  NOTARY_NOT_ASSIGNED: 'has not yet been assigned'
}
